import React, { useContext } from 'react';

import Confetti from 'react-confetti';

import ConsultantCheckoutContext from 'src/contexts/consultantCheckout';
import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';

import { formateDateTime } from 'src/utils/formateDateTime';

import {
  ContainerConsultant,
  ContainerHourAddress,
  ContainerInfo,
  ContainerName,
  ContainerRow,
  ContainerService,
  ContainerTitleAndIcon,
  IconCase,
  IconClock,
  IconConcluded,
  IconFaceToFace,
  IconOnline,
  ImageConsultant,
  MainSection,
  PaymentComponent,
  TextAddress,
  TextConcluded,
  TextInfo,
} from './style';

import concludedIconSVG from '../../../../assets/images/subscripiton-checkout-icons/checked-green-icon.svg';
import briefcasePNG from '../../../../assets/images/global-icons/briefcase.png';
import laptopPNG from '../../../../assets/images/global-icons/laptop.png';
import clockPNG from '../../../../assets/images/global-icons/clock.png';
import housePNG from '../../../../assets/images/global-icons/house.png';

export function PaymentConcludedConsultantService(): JSX.Element {
  const { fullAppointmentData } = useContext(ConsultantCheckoutContext);

  return (
    <PaymentComponent>
      <CheckoutHeader />
      <MainSection>
        <ContainerTitleAndIcon>
          <IconConcluded src={concludedIconSVG} />
          <TextConcluded>Pagamento confirmado!</TextConcluded>
        </ContainerTitleAndIcon>
        <ContainerInfo>
          <ContainerService>
            <IconCase src={briefcasePNG} alt="Maleta" />
            <p>{fullAppointmentData.serviceName}</p>
          </ContainerService>
          <>
            {fullAppointmentData.appointments
              .filter((app) => app.type === 'Online')
              .map((service, index) => (
                <ContainerHourAddress key={index}>
                  <ContainerRow gap="2.66vw">
                    <IconClock src={clockPNG} alt="Relógio" />
                    <TextInfo>{formateDateTime(service.date, service.startAt)}</TextInfo>
                  </ContainerRow>
                  <ContainerRow gap="2.13vw">
                    <IconOnline src={laptopPNG} alt="laptop" />
                    <TextInfo>Online</TextInfo>
                  </ContainerRow>
                </ContainerHourAddress>
              ))}
            {fullAppointmentData.appointments
              .filter((app) => app.type === 'Presencial')
              .map((service, index) => (
                <ContainerHourAddress key={index}>
                  <ContainerRow gap="2.66vw">
                    <IconClock src={clockPNG} alt="Relógio" />
                    <TextInfo>{formateDateTime(service.date, service.startAt)}</TextInfo>
                  </ContainerRow>
                  <ContainerRow gap="2.4vw">
                    <IconFaceToFace src={housePNG} alt="casa" />
                    <TextInfo>Presencial</TextInfo>
                  </ContainerRow>
                  <TextAddress>{service.address}</TextAddress>
                </ContainerHourAddress>
              ))}
          </>
        </ContainerInfo>
        <ContainerConsultant>
          <ImageConsultant
            src={`${process.env.REACT_APP_IMAGES_QA_BASE_URL}${fullAppointmentData.consultantProfileImage}`}
            alt="Foto de perfil da consultora"
          />
          <ContainerName>
            <p>Consultora</p>
            <h1>
              {fullAppointmentData.consultantName} - {fullAppointmentData.consultantCity},{' '}
              {fullAppointmentData.consultantState}
            </h1>
          </ContainerName>
        </ContainerConsultant>
      </MainSection>
      <FooterCheckout />
      <Confetti numberOfPieces={200} recycle={false} />
    </PaymentComponent>
  );
}
